import { createStore } from "zustand"

import type { TStatus } from "./form_tabs.interface"

interface IFormTabsState {
  currentTabIndex: number
  tabStatuses: (TStatus | undefined)[]
  length: number
  onSubmit: () => void
}

interface IFormTabsActions {
  initaliseTabs: (length: number) => void
  onNext: () => void
  onBack: () => void
  setTab: (index: number) => void
  setStatus: (status: TStatus) => void
}

export type TFormTabsStore = IFormTabsState & IFormTabsActions

export const createFormTabsStore = ({
  onSubmit,
}: Pick<IFormTabsState, "onSubmit">) =>
  createStore<TFormTabsStore>((set) => ({
    currentTabIndex: 0,
    tabStatuses: [],
    length: 0,
    onSubmit: onSubmit,
    initaliseTabs: (length) =>
      set({
        length: length,
        tabStatuses: Array(length).fill(undefined),
      }),
    onNext: () =>
      set((state) => {
        if (state.currentTabIndex < state.length - 1) {
          return { currentTabIndex: state.currentTabIndex + 1 }
        }
        return state
      }),
    onBack: () =>
      set((state) => {
        if (state.currentTabIndex > 0) {
          return { currentTabIndex: state.currentTabIndex - 1 }
        }
        return state
      }),
    setTab: (index) => set({ currentTabIndex: index }),
    setStatus: (status) =>
      set((state) => {
        const tabStatuses = [...state.tabStatuses]
        tabStatuses[state.currentTabIndex] = status
        return { tabStatuses }
      }),
  }))
